import { render, staticRenderFns } from "./ListCard.vue?vue&type=template&id=0b552083&"
import script from "./ListCard.vue?vue&type=script&lang=js&"
export * from "./ListCard.vue?vue&type=script&lang=js&"
import style0 from "./ListCard.vue?vue&type=style&index=0&id=0b552083&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports